import React, { useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, List as ListComponent, useDrawer, Confirm } from 'src/mtska-frontend-app-component';
import SplitButton from 'src/mtska-frontend-app-component/components/Button/SplitButton';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';

const dataProviderName = 'campaigns/campaign';
const drawerRouteBase = 'campaignmanagement';
const moduleName = "CampaignManagements";
const wizardAction = 'destroy';

const List = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);
    const { activate } = useDrawer();

    const apiRef = useGridApiRef();
    const getSelected = () => {
        return [...apiRef.current.getSelectedRows()].map(([name]) => name);
    };
    const [selected, setSelected] = useState([]);
    const handleRowSelection = (newSelection) => {
        setSelected(newSelection);
        params.rowSelectionExternalListener && params.rowSelectionExternalListener(newSelection);
    };

    const getFunctionalButtons = useMemo(() => {
        let rb = [];

        if (userCapabilities && userCapabilities[dataProviderName + '.delete'] && selected.length) {
            rb.push(
                <Button
                    disabled={userCapabilities && !userCapabilities[dataProviderName + '.delete']}
                    onClick={() => { handleDelete(); }}
                    label={t("Delete") + " (" + selected.length + ")"}
                    icon={"faTrash"}
                    variant="outlined"
                    size="small"
                    className="button-delete"
                />
            );
        }

        return rb;
    }, [selected, userCapabilities]);


    const [confirmDelete, setConfirmDelete] = useState();
    const handleDelete = () => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={async () => {
                    doAction && await doAction({ action: wizardAction, model: dataProviderName, data: getSelected() });
                    setConfirmDelete(null);
                    apiRef.current.setRowSelectionModel([]);
                    loadAll();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Items elimination")}>
                {t("Are you sure to remove the selected elements?")}
            </Confirm>
        );
    }

    const { doAction, loadAll, items, total, loading, reloadCounter } = useDataProvider(dataProviderName);
    const [listFilterPageSort, setListFilterPageSort] = useState();
    const handleFilterPageSortChange = (model) => {
        setListFilterPageSort(model);
    }

    useLoadAll({ listFilterPageSort, loadAll, params, reloadCounter })

    const handleRowDoubleclick = (row) => {
        const rowData = apiRef.current.getRow(row.id);
        console.info(rowData);
        if (rowData?.editingstatus == 'campaign_ready') {
            activate(drawerRouteBase + '/detail', { id: row.id });
        } else {
            activate(drawerRouteBase + '/create', { id: row.id });
        }
    }

    return (
        <>
            {userCapabilities && userCapabilities[dataProviderName + '.list'] && (
                <ListComponent
                    {...params}
                    onRowDoubleClick={(userCapabilities && userCapabilities[dataProviderName + '.view']) ? handleRowDoubleclick : () => { }}
                    onFilterPageSortChange={handleFilterPageSortChange}
                    items={items}
                    total={total}
                    loading={loading}
                    apiRef={apiRef}
                    enableSelection
                    rightButtons={[
                        ...getFunctionalButtons,
                        <SplitButton
                            className="gelsia-split-button"
                            actions={[
                                {
                                    disabled: userCapabilities && !userCapabilities[dataProviderName + '.create'],
                                    icon: "faAdd",
                                    label: t('New'),
                                    onClick: () => {
                                        activate(drawerRouteBase + '/create', {
                                            detailStack: params.detailStack ?? {},
                                            relatedElements: params.relatedElements ?? {}
                                        });
                                    }
                                },
                                // {
                                //     disabled: userCapabilities && !userCapabilities[dataProviderName + '.import'],
                                //     icon: "faDownload",
                                //     label: t('Import'),
                                //     onClick: () => {
                                //         activate('imports/list', {
                                //             filters: {
                                //                 items: [{
                                //                     operator: "equals",
                                //                     field: "model",
                                //                     value: dataProviderName,
                                //                 }]
                                //             },
                                //             currentDataProviderName: dataProviderName,
                                //             moduleName: moduleName,
                                //         });
                                //     }
                                // },
                                // {
                                //     disabled: userCapabilities && !userCapabilities[dataProviderName + '.export'],
                                //     disabledIfNoItemselected: false,
                                //     icon: "faUpload",
                                //     label: t('Export'),
                                //     onClick: () => {
                                //         activate(
                                //             'wizards/download',
                                //             {
                                //                 dataProviderName: dataProviderName,
                                //                 recipe: 'recipes.audiences.global',
                                //                 recipes: {
                                //                     'wysiwyg': 'Your current view',
                                //                     'recipes.audiences.global': 'Global view',
                                //                     'recipes.audiences.anagrafical': 'Anagrafical view'
                                //                 }
                                //             },
                                //         )
                                //     }
                                // },
                            ]}
                        />
                    ]}
                    dataProviderName={dataProviderName}
                    title={moduleName}
                    rowSelectionExternalListener={handleRowSelection}
                    doAction={doAction}
                />
            )}
            {confirmDelete}
        </>
    );
};

export default List;